package feature.product.viewModel

//import kotlinx.coroutines.IO
import feature.app.AppViewModel
import feature.auth.handler.AuthHandler
import feature.business.handler.BusinessHandler
import feature.product.handler.ProductHandler
import feature.product.model.Product
import feature.product.model.ProductBarCode
import feature.product.network.CreateProductRequest
import feature.product.network.ProductNetwork
import feature.product.network.RetrieveProductRequest
import feature.productCategory.handler.ProductCategoryHandler
import feature.productSubCategory.handler.ProductSubCategoryHandler
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock

class ProductViewModel : AppViewModel() {
    val repository = ProductHandler.shared().repository
    val searchQuery: StateFlow<String>
        get() = repository.searchQuery
    val allProduct: StateFlow<List<Product>>
        get() = ProductHandler.shared().repository.allProduct
    val newProduct: StateFlow<Product?>
        get() = ProductHandler.shared().repository.newProduct

    val productFormIndex: StateFlow<Int>
        get() = ProductHandler.shared().repository.productFormIndex

    val selectedProductState: MutableStateFlow<Product?> = MutableStateFlow(null)
    val selectedProduct: StateFlow<Product?>
        get() = selectedProductState

    fun setProductFormIndex(value: Int) {
        repository.setProductFormIndex(value)
    }

    override fun changeSearchQuery(value: String) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            repository.searchQueryState.emit(value)
        }
        performSearch(value)
    }

    override fun performSearch(value: String) {
        val searchQueryText = value.lowercase()
        CoroutineScope(Job() + Dispatchers.Default).launch {
            val filteredResult = repository.allProduct.value.filter { item ->
                item.Name?.lowercase()
                    ?.contains(searchQueryText) == true || item.Description.lowercase()
                    .contains(searchQueryText)
            } as ArrayList<Product>
            repository.allProductState.emit(filteredResult)
        }
    }

    fun setEditProduct(value: Product?) {
        repository.setEditProduct(value)
    }

    fun editProductName(value: String) {
        repository.editProduct.value?.Name = value
    }

    fun editProductSalePrice(value: String) {
        repository.editProduct.value?.ProductPrice?.FinalPrice = value.toFloat()
    }

    fun setNewProduct(value: Product?) {
        repository.setNewProduct(value)
    }

    fun setNewProductName(value: String) {
        repository.newProduct.value?.Name = value
    }

    fun setNewProductDescription(value: String) {
        repository.newProduct.value?.Description = value
    }

    fun setNewProductMrpPrice(value: String) {
        repository.newProduct.value?.ProductPrice?.MRP = value.toFloat()
    }

    fun setNewProductCostPricePrice(value: String) {
        repository.newProduct.value?.ProductPrice?.FinalPrice = value.toFloat()
    }

    fun setNewProductFinalPricePrice(value: String) {
        repository.newProduct.value?.ProductPrice?.FinalPrice = value.toFloat()
    }

    fun setNewProductSGST(value: String) {
        repository.newProduct.value?.ProductPrice?.SGST = value.toFloat()
    }

    fun setNewProductCGST(value: String) {
        repository.newProduct.value?.ProductPrice?.CGST = value.toFloat()
    }

    fun setNewProductIGST(value: String) {
        repository.newProduct.value?.ProductPrice?.IGST = value.toFloat()
    }

    fun setNewProductCESS(value: String) {
        repository.newProduct.value?.ProductPrice?.CESS = value.toFloat()
    }

    fun setNewProductVAT(value: String) {
        repository.newProduct.value?.ProductPrice?.VAT = value.toFloat()
    }

    fun setNewProductOtherTax(value: String) {
        repository.newProduct.value?.ProductPrice?.OtherTax = value.toFloat()
    }

    fun createProduct(
        callBack: (Boolean) -> Unit
    ) {
        if (repository.newProduct.value?.ProductPrice != null) {
            val request = CreateProductRequest(
                Clock.System.now().epochSeconds.toInt(),
                AuthHandler.shared().repository.authUser.value.id,
                BusinessHandler.shared().repository.business.value.Id,
                categoryID = ProductCategoryHandler.shared().repository.selectedCategory.value?.Id,
                subCategoryID = ProductSubCategoryHandler.shared().repository.selectedSubCategory.value?.Id,
                name = repository.newProduct.value?.Name ?: "",
                productPrice = repository.newProduct.value?.ProductPrice
            )
            startLoading()
            CoroutineScope(Job() + Dispatchers.Default).launch {
                ProductNetwork().create(request) {
                    stopLoading()
                    if (!it?.payload?.Id.isNullOrEmpty()) {
                        callBack(true)
                        CoroutineScope(Job() + Dispatchers.Default).launch {
                            repository.newProductState.emit(it!!.payload!!)
                        }
                    } else {
                        callBack(false)
                    }
                }
            }
        }
    }

    fun loadProduct() {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            repository.productLiveData.postValue(arrayListOf())
//            if (!BusinessHandler.shared().repository.business.value?.Id.isNullOrEmpty()) {
//                val businessId = BusinessHandler.shared().repository.business.value?.Id
//                if (!businessId.isNullOrEmpty()) {
//                    repository.productLiveData.postValue(
//                        DatabaseHandler.shared().database.productDao()
//                            .getProductsFor(businessId) as? ArrayList<Product>
//                    )
//                }
//            }
//        }
    }

    fun loadProductBarCode(product: Product) {
//        repository.productBarCodeLiveData.postValue(arrayListOf())
//        scope.launch {
//            val fetchedBarCodes =
//                DatabaseHandler.shared().database.productBarCodeDao().getForProduct(product.Id)
//            if (fetchedBarCodes.isNotEmpty()) {
//                repository.productBarCodeLiveData.postValue(fetchedBarCodes as ArrayList<ProductBarCode>)
//            }
//        }
    }

    fun findBarcodeById(barcode: String, callBack: (ProductBarCode?) -> Unit) {
//        scope.launch {
//            val fetchedBarCode =
//                DatabaseHandler.shared().database.productBarCodeDao().findById(barcode)
//            callBack(fetchedBarCode)
//        }
    }

    fun findProductByBarCode(barcode: String, callBack: (Product?) -> Unit) {
//        scope.launch {
//            findBarcodeById(barcode) { barcode ->
//                if (barcode != null && !barcode.ProductID.isNullOrEmpty()) {
//                    scope.launch {
//                        val foundProduct = DatabaseHandler.shared().database.productDao()
//                            .findById(barcode.ProductID)
//                        callBack(foundProduct)
//                    }
//                }
//            }
//        }
    }

    fun fetchAllProduct() {
        val business = BusinessHandler.shared().repository.business
        if (business.value.Id.isEmpty()) {
            return
        }
        val request = RetrieveProductRequest(business.value.Id)
        startLoading()
        ProductNetwork().retrieve(request) {
            stopLoading()
            if (it?.payload?.isNotEmpty() == true) {
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    repository.allProductState.emit(it.payload)
                }
            }
        }
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        scope.launch {
//            val syncTime =
//                DatabaseHandler.shared().database.productDao().recentUpdatedAt(business.value!!.Id)
//            request.put(KeyConstant.lastSyncDate, syncTime)
//            ProductNetwork.shared().retrieve(request) { responseJson ->
//                try {
//                    val payload = responseJson?.getJSONArray(KeyConstant.payload)
//                    if (payload != null) {
//                        for (i in 0 until payload.length()) {
//                            val item = payload.getJSONObject(i)
//                            val product = Gson().fromJson(item.toString(), Product::class.java)
//                            insertProduct(product)
//                        }
//                        loadProduct()
//                    }
//                    loadProduct()
//                } catch (e: Exception) {
//                    e.printStackTrace()
//                }
//
//            }
//        }


    }

//
//    fun updateProduct(request: JSONObject) {
//        SocketService.shared().send(SocketEvent.UPDATE_PRODUCT, request)
//    }
//
//    fun updateProductImage(product: Product, image: String) {
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.fileURL, image)
//        request.put(KeyConstant._id, product.Id)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.featureObjectID, product.Id)
//        MediaFileHandler.shared().viewModel?.createNew(request)
//    }
//
//    fun deleteProduct(product: Product) {
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant._id, product.Id)
//        product.IsDeleted = true
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.productDao()
//                .update(product)
//        }
//        SocketService.shared().send(SocketEvent.DELETE_PRODUCT, request)
//    }
//
//    fun removeStockQuantity(product: Product, quantity: Int, message: String) {
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.productID, product.Id)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.quantity, quantity)
//        request.put(KeyConstant.comment, message)
//        SocketService.shared().send(SocketEvent.REMOVE_STOCK_QUANTITY, request)
//    }
//
//    fun addStockQuantity(product: Product, quantity: Int, message: String) {
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.productID, product.Id)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.quantity, quantity)
//        request.put(KeyConstant.comment, message)
//        SocketService.shared().send(SocketEvent.ADD_STOCK_QUANTITY, request)
//    }
//
//    fun resetStockQuantity(product: Product, quantity: Int, message: String) {
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.productID, product.Id)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.quantity, quantity)
//        request.put(KeyConstant.comment, message)
//        SocketService.shared().send(SocketEvent.RESET_STOCK_QUANTITY, request)
//    }
//
//    fun insertStock(stockEntry: ProductStock) {
//        scope.launch {
//            DatabaseHandler.shared().database.productStockDao()
//                .insert(stockEntry)
//        }
//    }
//
//    fun insertProduct(product: Product) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.productDao()
//                .insert(product)
//        }
//    }
//
//    fun createBarCode(product: Product, code: String) {
//        val unixTime = System.currentTimeMillis()
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.uniqueId, unixTime)
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.productID, product.Id)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.barcode, code)
//        SocketService.shared().send(SocketEvent.CREATE_PRODUCT_BAR_CODE, request)
//    }
//
//    fun insertProductBarCode(barCode: ProductBarCode) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.productBarCodeDao()
//                .insert(barCode)
//        }
//    }


}
